import * as React from 'react'
import { Phone } from 'react-feather'

import { Text } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'
import { i18nKeyPrefix } from '../../../pages/School/i18n'
import { formatE164USPhoneAsHuman } from '../../../util/phone'
import { Bullet, InfoSection } from '../common'

interface IProps {
  phoneNumber: string | null
}

export default function PhoneNumber(props: IProps) {
  const phoneNumber = props.phoneNumber
  const formattedPhoneNumber = formatE164USPhoneAsHuman(phoneNumber)
  const PRE = `${i18nKeyPrefix}-PHONE-NUMBER`
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <InfoSection title={t(`${PRE}-COPY-TITLE`)}>
      <Text>{t(`${PRE}-COPY`)}</Text>
      <a href={`tel:${phoneNumber}`} style={{ textDecoration: 'none' }}>
        <Bullet icon={<Phone />}>
          <Text>{formattedPhoneNumber}</Text>
        </Bullet>
      </a>
    </InfoSection>
  )
}
